import {AbstractEvent} from "@/modules/base/events";
import {Application} from "@/di";

export class AppLoadedEvent extends AbstractEvent {
  constructor(
    public application: Application
  ) {
    super();
  }
}
